var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgGameActiveIcon = function SvgGameActiveIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 13.125L5.278 15.722C4.98896 16.011 4.62073 16.2078 4.21986 16.2875C3.819 16.3672 3.40349 16.3263 3.02588 16.1699C2.64827 16.0135 2.32552 15.7486 2.09841 15.4088C1.87131 15.069 1.75006 14.6695 1.75 14.2608V13.125L2.93738 7.189C3.09596 6.39557 3.52455 5.68159 4.15023 5.16855C4.7759 4.6555 5.56 4.37508 6.36913 4.375H14.6309C15.44 4.37508 16.2241 4.6555 16.8498 5.16855C17.4754 5.68159 17.904 6.39557 18.0626 7.189L19.25 13.125V14.2599C19.2499 14.6686 19.1287 15.0681 18.9016 15.4079C18.6745 15.7477 18.3517 16.0126 17.9741 16.169C17.5965 16.3254 17.181 16.3663 16.7801 16.2866C16.3793 16.2069 16.011 16.0101 15.722 15.7211L13.125 13.125H7.875Z",
    stroke: "#BE7EFF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 4.375L8.75 6.125H12.25L13.125 4.375",
    stroke: "#BE7EFF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGameActiveIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/game-active-icon.db74fc80.svg";
export { ForwardRef as ReactComponent };